"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const localforage_1 = tslib_1.__importDefault(require("localforage"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const localforage_memoryStorageDriver_1 = tslib_1.__importDefault(require("localforage-memoryStorageDriver"));
const utils_1 = require("./utils");
class CacheLayer {
    getStorageDriver(storageType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (storageType === 'indexeddb') {
                const useIndexedDB = yield (0, utils_1.isIndexedDBAvailable)();
                if (useIndexedDB) {
                    return localforage_1.default.INDEXEDDB;
                }
                console.warn('IndexedDB is not available, falling back to memory storage');
            }
            else if (storageType === 'localstorage') {
                return localforage_1.default.LOCALSTORAGE;
            }
            yield localforage_1.default.defineDriver(localforage_memoryStorageDriver_1.default);
            return localforage_memoryStorageDriver_1.default._driver;
        });
    }
    registerDatabase(key, storeName, storageType) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const storageDriver = yield this.getStorageDriver(storageType);
            const settings = {
                driver: storageDriver,
                name: `ps-${key}`,
                version: 1.0,
                storeName: storeName,
            };
            this.storage = localforage_1.default.createInstance(settings);
            yield this.storage.clear();
            this.isReady = true;
        });
    }
    ready() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.isReady) {
                return Promise.resolve();
            }
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    if (this.isReady) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 5);
            });
        });
    }
    constructor({ storageName, storeName, storageType = 'memory' }) {
        this.isReady = false;
        this.registerDatabase(storageName, storeName, storageType);
    }
    set(key, value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.ready();
                return yield this.storage.setItem(String(key), value);
            }
            catch (error) {
                console.error(error);
                return null;
            }
        });
    }
    get(key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.ready();
                return yield this.storage.getItem(String(key));
            }
            catch (error) {
                console.error(error);
                return null;
            }
        });
    }
    delete(key) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                yield this.ready();
                return yield this.storage.removeItem(String(key));
            }
            catch (error) {
                console.error(error);
                return null;
            }
        });
    }
}
exports.default = CacheLayer;
//# sourceMappingURL=cache.js.map